import React from 'react';
import { Modal, Typography } from 'antd';
import { formatQuotationPrintIdentity } from '@/utils/quotationRevisionPolicy';
import { formatMoney, UAE_MONEY_PROFILE } from '@/utils/format';
import type { Quotation } from '@/services/quotation.service';
import { displayQuotationRevisionLabel } from '@/utils/quotationRevisionPolicy';

const { Text, Paragraph } = Typography;

type Props = {
  open: boolean;
  quotation: Quotation;
  priorOfferRevision?: number | null;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const QuotationSendConfirmModal: React.FC<Props> = ({
  open,
  quotation,
  priorOfferRevision,
  loading,
  onCancel,
  onConfirm,
}) => {
  const rev = displayQuotationRevisionLabel(quotation.revision_number);
  const prior =
    priorOfferRevision != null ? displayQuotationRevisionLabel(priorOfferRevision) : null;

  return (
    <Modal
      title="Send to Customer"
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      confirmLoading={loading}
      okText="Confirm Submission"
    >
      <Paragraph>
        You are about to make <Text strong>{rev}</Text> the current customer offer for{' '}
        <Text strong>{quotation.quotation_number}</Text>.
      </Paragraph>
      {prior ? (
        <Paragraph type="warning">
          This will supersede the prior customer offer ({prior}).
        </Paragraph>
      ) : null}
      <Text type="secondary">
        Backend authority unchanged — prior Sent/Accepted siblings will be marked Revised per
        supersession rules.
      </Text>
    </Modal>
  );
};

export default QuotationSendConfirmModal;
